export const menuGroupDashboardProfessional = 'dashboardProfessional';
export const menuGroupDashboardBasic = 'dashboardBasic';
export const menuGroupAssetManagementName = 'assetManagement';
export const menuGroupCashPaymentName = 'cashPayment';
export const menuGroupCashReceiptName = 'cashReceipt';
export const menuGroupCashTransferName = 'cashTransfer';
